module.exports = __webpack_public_path__ + "static/media/transfer-abroad-icon.61ef4f7a.svg";